<div class="flex flex-col gap-6">
  <section>
    <h4 class="mb-2 font-semibold text-gray-700">Historial de estado (últimas 24 h)</h4>
    @if (statusChart; as options) {
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="options"
      [oneToOne]="true"
      style="width: 100%; height: 110px; display: block"
    />
    <div class="flex flex-wrap justify-center gap-3 text-xs text-gray-500">
      @for (status of statusPresent; track status) {
      <span class="flex items-center gap-1">
        <span
          class="inline-block h-2 w-2 rounded-full"
          [style.background]="statusColors[status] ?? '#9ca3af'"
        ></span>
        {{ status }}
      </span>
      }
    </div>
    } @else if (statusLoaded) {
    <p class="text-sm text-gray-500">Sin historial de estado disponible.</p>
    } @else {
    <div class="h-[110px] w-full animate-pulse rounded bg-gray-100"></div>
    }
  </section>

  @for (kind of kinds; track kind) {
  <section>
    <div class="mb-2 flex flex-wrap items-center justify-between gap-2">
      <h4 class="font-semibold text-gray-700">{{ kind === 'traffic' ? 'Tráfico' : 'Señal' }}</h4>
      <p-selectButton
        [options]="periods[kind]"
        optionLabel="label"
        optionValue="value"
        [allowEmpty]="false"
        styleClass="p-button-sm"
        [(ngModel)]="period[kind]"
        (onChange)="load(kind)"
      />
    </div>
    @if (charts[kind]; as options) {
    <!-- un gráfico nuevo por cada carga: al actualizar el mismo, Highcharts dejaba los marcadores
         de Mes dibujados encima del Año -->
    @for (chart of [options]; track chart) {
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="chart"
      style="width: 100%; height: 220px; display: block"
    />
    } @if (dataSince[kind]; as since) {
    <p class="mt-1 flex items-center gap-1.5 text-xs text-gray-500">
      <i class="pi pi-info-circle text-[11px]"></i>
      SmartOLT no tiene datos de esta ONU antes del {{ since | date: 'dd/MM/yyyy' : 'UTC' }}: el
      gráfico empieza ese día.
    </p>
    }
    <div class="mt-1 flex flex-wrap items-center gap-x-6 gap-y-1 text-xs text-gray-600">
      @for (stat of stats[kind]; track stat.name) {
      <span class="flex items-center gap-1">
        <span class="inline-block h-2 w-3 rounded-sm" [style.background]="stat.color"></span>
        <strong>{{ stat.name }}</strong> Actual: {{ stat.current }} · Máximo: {{ stat.max }}
      </span>
      } @if (kind === 'traffic') {
      <button type="button" class="ml-auto text-blue-600 hover:underline" (click)="toggleUsage()">
        <i class="pi pi-chart-bar"></i> Uso de tráfico
      </button>
      }
    </div>
    @if (kind === 'traffic' && usageOpen) { @if (usage === null) {
    <div class="mt-2 h-16 animate-pulse rounded bg-gray-100"></div>
    } @else {
    <table class="mt-2 min-w-full text-sm" aria-describedby="Uso de tráfico">
      <thead class="border-b-2 border-blue-400">
        <tr>
          <th class="px-3 py-1 text-left"></th>
          <th class="px-3 py-1 text-right">Descarga</th>
          <th class="px-3 py-1 text-right">Subida</th>
          <th class="px-3 py-1 text-right">Total</th>
        </tr>
      </thead>
      <tbody>
        @for (row of usage; track row.period) {
        <tr class="border-b">
          <td class="px-3 py-1">{{ row.period }}</td>
          <td class="px-3 py-1 text-right">{{ row.download }}</td>
          <td class="px-3 py-1 text-right">{{ row.upload }}</td>
          <td class="px-3 py-1 text-right font-semibold">{{ row.total }}</td>
        </tr>
        } @empty {
        <tr>
          <td colspan="4" class="px-3 py-2 text-gray-500">
            No se pudo leer el consumo. Intente en unos minutos.
          </td>
        </tr>
        }
      </tbody>
    </table>
    } } } @else if (empty[kind]) {
    <p class="rounded bg-gray-50 p-4 text-center text-sm text-gray-500">
      Aún no hay datos del gráfico para este equipo.
    </p>
    } @else {
    <div class="h-[220px] w-full animate-pulse rounded bg-gray-100"></div>
    }
  </section>
  }
</div>
